import Icon from '2-core-elements/Icon/Icon';
import { type FC } from 'react';

interface ThankYouMessageProps {
    children: React.ReactNode;
}

const ThankYouMessage: FC<ThankYouMessageProps> = ({ children }) => {
    return (
        <div className="thank-you-message">
            <div className="thank-you-message-content-wrapper">
                <Icon icon={'heart-hands'} />
                <div className="thank-you-message-content">
                    <div className="thank-you-message-title">Thank you!</div>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default ThankYouMessage;
